import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navigation } from "@/components/landing/Navigation";
import { HalloweenBats } from "@/components/landing/HalloweenBats";
import { Hero } from "@/components/landing/Hero";
import { About } from "@/components/landing/About";
import { Book } from "@/components/landing/Book";
import { Programs } from "@/components/landing/Programs";
import { Partners } from "@/components/landing/Partners";
import { Values } from "@/components/landing/Values";
import { Skills } from "@/components/landing/Skills";
import { Admissions } from "@/components/landing/Admissions";
import { Campus } from "@/components/landing/Campus";
import { Access } from "@/components/landing/Access";
import { Housing } from "@/components/landing/Housing";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";

const LandingPage = () => {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-slate-50">
      <HalloweenBats />
      <Navigation />
      <main>
        <Hero />
        <About />
        <Book />
        <Programs />
        <Partners />
        <Values />
        <Skills />
        <Admissions />
        <Campus />
        <Housing />
        <Access />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
